import { setCookie } from 'nookies'
import { useLocation } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

export function ModalLogin() {
  const location = useLocation()

  function handleRedirect(path: string) {
    const currentPath = location.pathname + location.search
    setCookie(null, 'redirectAfterLogin', currentPath, {
      path: '/',
      expires: new Date('2238-01-01'),
    })

    window.location.href = path
  }

  return (
    <Dialog open>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-center text-xl font-semibold">
            Acesse sua conta
          </DialogTitle>
          <DialogDescription className="mt-2 text-center text-gray-500">
            Para acessar todas as funcionalidades do site, você precisa estar
            logado. Se ainda não tem uma conta, pode criar uma agora mesmo!
          </DialogDescription>
        </DialogHeader>

        <div className="mt-4 flex justify-center gap-4">
          <Button onClick={() => handleRedirect('/sign-in')} className="w-32">
            Fazer login
          </Button>
          <Button
            variant="outline"
            onClick={() => handleRedirect('/sign-up')}
            className="w-32 border-blue-600 text-blue-600 hover:bg-blue-100"
          >
            Criar conta
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
